<template>
  <div
    id="reserveModal"
    class="modal fade bd-example-modal-lg"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" id="exampleModalLabel">
            預約單詳細資料 - {{ reserveType }}
          </h3>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="closeModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <Top />
          <hr />
          <Mid />
          <CarStateTable />
          <hr />
          <Bottom ref="bottom" />
          <hr />
          <MessageTable />
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal"
          >
            關閉
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Top from './Top'
import Mid from './Mid'
import CarStateTable from './CarStateTable'
import Bottom from './Bottom'
import MessageTable from './MessageTable'

export default {
  components: {
    Top,
    Mid,
    CarStateTable,
    Bottom,
    MessageTable,
  },
  computed: {
    ...mapState('reserveModal', {
      vx_billInfo: 'billInfo',
      vx_openAt: 'openAt',
    }),
    reserveType() {
      return this.vx_billInfo.reservationType === 0 ? '一般預約' : '機場接送'
    },
  },
  methods: {
    ...mapActions('transaction', {
      vx_fetchTransList: 'fetchList',
    }),
    ...mapActions('reservation', {
      vx_fetchReserveList: 'fetchList',
    }),
    openModal() {
      /* 初始化modal中state的內容 */
      this.$refs.bottom.initNote()
      $('#reserveModal').modal({ backdrop: 'static', keyboard: true })
    },
    closeModal() {
      /* 初始化modal中state的內容 */
      /* this.$refs.bottom.initNote() */
      $('#reserveModal').modal('hide')
      /* 更新modal外列表的資料 */
      if (this.vx_openAt === '預約單') {
        this.vx_fetchReserveList()
      } else if (this.vx_openAt === '叫車紀錄總查詢') {
        this.vx_fetchTransList()
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/reserveModal/index.vue